/**
 * Canonical share-base URL for outbound invite links.
 *
 * Why not `window.location.origin`?
 *   - Inside the Capacitor WebView, Capacitor's `server.url` (allurexp.com)
 *     usually makes this correct — but during development / previews the
 *     origin can be `capacitor://localhost`, `https://localhost`, or a
 *     preview domain, which would break the shared link for the invitee.
 *   - Android App Links only verify for the domains declared in
 *     AndroidManifest.xml (`allurexp.com`, `www.allurexp.com`) — links using
 *     any other origin will always bounce out to the browser.
 *
 * We therefore always mint invite URLs against the canonical public host.
 * Override via `REACT_APP_SHARE_BASE_URL` only if the production domain
 * ever changes.
 */
export const SHARE_BASE_URL = (
  process.env.REACT_APP_SHARE_BASE_URL || 'https://allurexp.com'
).replace(/\/+$/, '');

export const buildShareUrl = (path) => {
  const p = String(path || '');
  return `${SHARE_BASE_URL}${p.startsWith('/') ? p : `/${p}`}`;
};
